import io from 'socket.io-client';
import { BASE_URL } from '../helper/helper';

class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
  }

  connect(userData) {
  if (!this.socket) {
    this.socket = io(BASE_URL, {
      transports: ['websocket', 'polling']
    });

    this.socket.on('connect', () => {
      console.log('Connected to server');
      this.isConnected = true;
    });

    this.socket.on('disconnect', () => {
      this.isConnected = false;
    });
  }

  // 🔥 ALWAYS EMIT JOIN (important)
  if (this.socket.connected) {
    this.socket.emit('join', userData);
  } else {
    this.socket.once('connect', () => {
      this.socket.emit('join', userData);
    });
  }

  return this.socket;
}


  onConnect(callback) {
  if (this.socket?.connected) {
    callback();
  } else if (this.socket) {
    this.socket.once('connect', callback);
  }
}


  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  joinChat(chatId) {
    if (this.socket) {
      this.socket.emit('join_chat', chatId);
    }
  }

  leaveChat(chatId) {
    if (this.socket) {
      this.socket.emit('leave_chat', chatId);
    }
  }

  sendMessage(messageData) {
    if (this.socket) {
      this.socket.emit('send_message', messageData);
    }
  }

  startTyping(chatId, userName) {
    if (this.socket) {
      this.socket.emit('typing', { chatId, userName, isTyping: true });
    }
  }

  stopTyping(chatId, userName) {
    if (this.socket) {
      this.socket.emit('typing', { chatId, userName, isTyping: false });
    }
  }

  onNewMessage(callback) {
    if (this.socket) {
      this.socket.on('new_message', callback);
    }
  }

  onNewNotification(callback) {
    if (this.socket) {
      this.socket.on('new_notification', callback);
    }
  }

  offNewNotification(callback) {
    if (this.socket && callback) {
      this.socket.off('new_notification', callback);
    }
  }

  onUserTyping(callback) {
    if (this.socket) {
      this.socket.on('user_typing', callback);
    }
  }

  onMessageError(callback) {
    if (this.socket) {
      this.socket.on('message_error', callback);
    }
  }

  removeAllListeners() {
    if (this.socket) {
      this.socket.removeAllListeners();
    }
  }
}

export default new SocketService();
